import React from 'react'

import { Button } from '@mui/material'

const ActionButton = ({ label, color = 'primary', disabled = false, onClick, ...rest }) => {
    return (<Button {...rest} variant={color === 'secondary' ? 'outlined' : 'contained'} color={color} disabled={disabled} onClick={onClick}>{ label }</Button>)
}

export default ActionButton